import { Button, Notice, SampleChip } from "@omnabase/ui";

/** M11 round two (brief choice 7): the banner on the sample ticket, ported from the prototype: the kit's "Sample" chip, what the ticket is,
 *  and "Delete sample" for the owner alone (the ticket, Anna, the draft and the article go; everyone else reads the banner without it). */
export function SampleBanner({ owner, onDelete }: { owner: boolean; onDelete: () => void }) {
  return (
    <div className="ob-sample-banner">
      <Notice icon="info" action={owner ? <Button size="sm" icon="trash" onClick={onDelete}>Delete sample</Button> : undefined}>
        <SampleChip className="ob-sample-banner__chip" /> <strong>A made-up ticket.</strong> Nothing on it is ever mailed. Try the draft: send it, edit it or discard it.
      </Notice>
    </div>
  );
}
